import {
  DownloadResultManager,
  ServiceUsingCountManager,
} from "@/services/license/base/license-manager-abstractions";
import { AiMasteringDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/ai-mastering-download-result-limiter";
import { AiMasteringUsingCountLimiter } from "@/services/license/license-limiters/service-using-count-limiters/ai-mastering-using-count-limiter";

export class AiMasteringLicenseManager
  implements DownloadResultManager, ServiceUsingCountManager
{
  serviceUsingCountLimiter = new AiMasteringUsingCountLimiter();
  downloadResultLimiter = new AiMasteringDownloadResultLimiter();
}

const aiMasteringLicenseManager = new AiMasteringLicenseManager();
export { aiMasteringLicenseManager };
